// @flow
import $ from 'jquery';
import 'fg-frontend/plugins/required/jquery.cookies-policy';

/**
 * JS oznámení o použití cookies na webu
 * default nastavení - viz: fg-frontend/plugins/required/jquery.cookies-policy
 *
 * * možnost redefinovat si styly přidáním parametru přes parametr css, případně je barvu tlačítka a odkazu: css.brandColor
 * * position - určuje vložení do požadovaného elementu na začátek (position: 'top') nebo na konec (position: 'bottom'),
 * * možnost definovat si vlastní textaci přes parametr messages.lang: (defaulty jsou v CS, SK, EN, DE, RU, ES)
 */
export default (): void => {
  $('body').cookiesPolicy({
    lang: window.projectConfig.lang,
    disableCss: true,
    position: 'bottom',
    messages: {
      'cs': {
        text: 'Tento web používá k&nbsp;poskytování funkcí sociálních médií a&nbsp;analýze návštěvnosti soubory cookies. Kliknutím na tlačítko „Rozumím“ souhlasíte s&nbsp;jejich používáním.',
        link: '/cs/informace-o-webu',
        linkText: 'Více o&nbsp;používání cookies.',
        accept: 'Rozumím',
      },
    },
    template: function(data) {
      return `<div class="cookies">
								<p class="cookies__content">${data.text} <a href="${data.link}">${data.linkText}</a></p>
								<p class="cookies__button-container"><a class="btn btn--primary btn--sm js_acceptCookies js_buttonStyle" href="javascript:void(0)">${data.accept}</a></p>					
							</div>`;
    },
  });
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/CookiesPolicy.js